import { render, staticRenderFns } from "./NsHeaderAem.vue?vue&type=template&id=4713656e&scoped=true&"
import script from "./NsHeaderAem.vue?vue&type=script&lang=js&"
export * from "./NsHeaderAem.vue?vue&type=script&lang=js&"
import style0 from "./NsHeaderAem.vue?vue&type=style&index=0&id=4713656e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4713656e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4713656e')) {
      api.createRecord('4713656e', component.options)
    } else {
      api.reload('4713656e', component.options)
    }
    module.hot.accept("./NsHeaderAem.vue?vue&type=template&id=4713656e&scoped=true&", function () {
      api.rerender('4713656e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/app-components/components/NsHeaderAem.vue"
export default component.exports